/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3VIcon16Solid = forwardRef('UiMenuDots3VIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.499 2.999a1.499 1.499 0 1 1-2.998 0 1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M9.499 8A1.499 1.499 0 1 1 6.5 8a1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M8 14.498A1.499 1.499 0 1 0 8 11.5a1.499 1.499 0 0 0 0 2.998Z" })));
});
